<script>
import { clone, fill, isEqual, isNil } from 'lodash/fp'

const FilterList = () => import('./FilterList') // eslint-disable-line
const FilterCheckbox = () => import('./FilterCheckbox') // eslint-disable-line
const FilterCheckboxList = () => import('./FilterCheckboxList') // eslint-disable-line
const FilterRange = () => import('./FilterRangeWithGoButton') // eslint-disable-line
const FilterSelect = () => import('./FilterSelect') // eslint-disable-line

export default {
  name: 'FilterFacet',
  props: {
    absolute: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    filters: Array,
    filterValues: Array,
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      listValue: null
    }
  },
  computed: {
    hasFilterValues () {
      return this.filterValues.some(value => !isNil(value))
    }
  },
  methods: {
    closeDrawer () {
      this.$emit('update:expanded', false)
    },

    drawerInput (value) {
      this.$emit('update:expanded', value)
    },
    clearAllFilters () {
      const newfilterValues = fill(0, this.filterValues.length, null, Array(this.filterValues.length))
      this.$emit('update:filterValues', newfilterValues)
    },
    filterChanged (filter, index, event) {
      const currentValue = this.filterValues[index]

      // Check if they are equal
      if (isEqual(currentValue, event)) {
        return null
      }

      let newfilterValues = this.filterValues.reduce((acc, curr, currentIndex) => {
        acc.push(currentIndex === index ? clone(event) : curr)
        return acc
      }, [])

      this.$emit('update:filterValues', newfilterValues)
    }
  },
  render (h) {
    const filterRenderStrategies = {}

    /*
      Select
     */
    const selectFilter = (filter, index) => {
      return filter.type === 'select' && (
        <FilterSelect
          filter={filter}
          filterIndex={index}
          value={this.filterValues[index]}
          onUpdate={(e) => { this.filterChanged(filter, index, e) }}
        />
      )
    }
    filterRenderStrategies['select'] = selectFilter

    /*
      List
    */
    const listFilter = (filter, index) => {
      return filter.type === 'list' && (
        <FilterList
          filter={filter}
          filterIndex={index}
          value={this.filterValues[index]}
          onUpdate={(e) => { this.filterChanged(filter, index, e) }}
        />
      )
    }
    filterRenderStrategies['list'] = listFilter

    /*
    Range
    */
    const rangeFilter = (filter, index) => {
      /*
      return (
        <div>Range Slider</div>
      )
    */
      return filter.type === 'range' && (
        <FilterRange
          filter={filter}
          filterIndex={index}
          value={this.filterValues[index]}
          onUpdate={(e) => { this.filterChanged(filter, index, e) }}
        />
      )
    }
    filterRenderStrategies['range'] = rangeFilter

    /*
      Checkbox
    */
    const booleanFilter = (filter, index) => {
      return filter.type === 'checkbox' && (
        <FilterCheckbox
          filter={filter}
          filterIndex={index}
          value={this.filterValues[index]}
          onUpdate={(e) => { this.filterChanged(filter, index, e) }}
        />
      )
    }
    filterRenderStrategies['checkbox'] = booleanFilter

    /*
      Checkbox List
    */
    const checkboxListFilter = (filter, index) => {
      return filter.type === 'checkboxList' && (
        <FilterCheckboxList
          filter={filter}
          filterIndex={index}
          value={this.filterValues[index]}
          onUpdate={(e) => { this.filterChanged(filter, index, e) }}
        />
      )
    }
    filterRenderStrategies['checkboxList'] = checkboxListFilter

    /*
      Switch

    const SwitchFilter = (filter, index) => {
      return filter.type === 'switch' && (
        <div>
          Switch Slider Filter for:
          {filter.value}
        </div>
      )
    }
    filterRenderStrategies['switch'] = SwitchFilter
    */

    // Create Filters
    const filters = this.filters.map((filter, index) =>
      <v-flex>
        {filterRenderStrategies[filter.type](filter, index)}
      </v-flex>
    )

    const clearAllButton = (
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          onClick={this.clearAllFilters}
          disabled={!this.hasFilterValues}
          class="ma-0"
          icon>
          <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
      Clear All Filters
      </v-tooltip>
    )

    const filterList = <v-list dense expand>
      {filters}
    </v-list>

    return (
      <v-navigation-drawer
        fixed
        value={this.expanded}
        onInput={this.drawerInput}

        fixed={this.$vuetify.breakpoint.mdAndUp}
        app={!this.absolute}
        clipped={this.$vuetify.breakpoint.mdAndUp}
        floating={this.$vuetify.breakpoint.smAndDown}

        disableRouteWatcher={true}
        disableResizeWatcher={true}
        right
      >
        <v-toolbar flat class="transparent">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-icon>mdi-filter-variant</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Filters</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                {clearAllButton}
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-toolbar>

        {filterList}
      </v-navigation-drawer>
    )
  }
}
</script>

<style lang="stylus" scoped>
</style>
